'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoryViewer = {

  stories: {},

  viewer: false,
  init: function init(p) {
    StoryViewer.viewer = _n.qs('#storyViewer');
    p = p || document;
    _n.qsa('[data-story]').forEach(function (el) {

      el.addEventListener('click', function (event) {
        StoryViewer.open(el.dataset.story, 0, event.pageX, event.pageY);
      });

      if (!StoryViewer.stories[el.dataset.story]) {
        fetch('/products/' + el.dataset.story + '.json').then(function (r) {
          return r.json();
        }).then(function (d) {
          StoryViewer.stories[el.dataset.story] = d;
        });
      }
    });
    var mc = new Hammer(_n.qs('#storyViewer'), {});
    mc.on("pan", function (e) {
      if (e.deltaY < -100 && e.direction == 2) StoryViewer.close();
    });
  },

  open: function open(url, page, x, y, position) {

    StoryViewer.active_story = StoryViewer.stories[url];
    StoryViewer.active_story.url = url;

    StoryViewer.next_story = false;
    try {
      StoryViewer.next_story = StoryViewer.stories[Object.keys(StoryViewer.stories)[Object.keys(StoryViewer.stories).indexOf(url) + 1]];
      StoryViewer.next_story.url = Object.keys(StoryViewer.stories)[Object.keys(StoryViewer.stories).indexOf(url) + 1];
    } catch (err) {}

    StoryViewer.prev_story = false;
    try {
      StoryViewer.prev_story = StoryViewer.stories[Object.keys(StoryViewer.stories)[Object.keys(StoryViewer.stories).indexOf(url) - 1]];
      StoryViewer.prev_story.url = Object.keys(StoryViewer.stories)[Object.keys(StoryViewer.stories).indexOf(url) - 1];
    } catch (err) {}

    Neptune.liquid.load('storyViewer', StoryViewer);

    // StoryViewer.viewer.style.position = position || 'absolute'

    modal.open('storyViewer');

    if (x - StoryViewer.viewer.offsetWidth / 2 < 0) x = StoryViewer.viewer.offsetWidth / 2;

    StoryViewer.viewer.style.left = x + 'px';

    // if(y - StoryViewer.viewer.offsetHeight/2 < 0 )
    //   y = StoryViewer.viewer.offsetHeight/2

    // StoryViewer.viewer.style.top = `${y}px`

    setTimeout(StoryViewer.slideChange, 200);
  },

  nextStory: function nextStory() {
    if (!!StoryViewer.next_story) {
      var transform = _n.qs('#storyViewer .swiper-wrapper').style.transform;
      _n.qs('#storyViewer .swiper').swiper.detachEvents();
      _n.qs('#storyViewer .swiper-wrapper').style.transform = transform;
      _n.qs('#storyViewer .swiper-wrapper').style.transition = 'all 300ms ease-in-out';
      _n.qs('#storyViewer .swiper-wrapper').style.marginLeft = '-100%';
      setTimeout(function () {
        StoryViewer.open(StoryViewer.next_story.url);
      }, 300);
    }
  },
  prevStory: function prevStory() {
    if (!!StoryViewer.prev_story) {
      var transform = _n.qs('#storyViewer .swiper-wrapper').style.transform;
      _n.qs('#storyViewer .swiper').swiper.detachEvents();
      _n.qs('#storyViewer .swiper-wrapper').style.transform = transform;
      _n.qs('#storyViewer .swiper-wrapper').style.transition = 'all 300ms ease-in-out';
      _n.qs('#storyViewer .swiper-wrapper').style.marginLeft = '100%';
      setTimeout(function () {
        StoryViewer.open(StoryViewer.prev_story.url);
      }, 300);
    }
  },

  brightness: function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(imgUrl) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new Promise(function (resolve) {

                var img = new Image();
                img.crossOrigin = 'Anonymous';

                img.addEventListener('load', function () {

                  var canvas = document.createElement("canvas");
                  var context = canvas.getContext('2d');
                  canvas.width = img.width;
                  canvas.height = img.height;

                  var colorSum = 0;

                  context.drawImage(img, 0, 0);

                  var data = context.getImageData(0, 0, canvas.width, Math.floor(canvas.height / 5)).data;

                  var r, g, b, avg;

                  for (var x = 0, len = data.length; x < len; x += 4) {
                    r = data[x];
                    g = data[x + 1];
                    b = data[x + 2];

                    avg = Math.floor((r + g + b) / 3);
                    colorSum += avg;
                  }

                  console.log(img);

                  var brightness = Math.floor(colorSum / (img.width * Math.floor(img.height / 5)));

                  resolve(brightness);
                });

                img.src = imgUrl;
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function brightness(_x) {
      return _ref.apply(this, arguments);
    };
  }(),

  slideChange: function slideChange() {
    setTimeout(function () {
      StoryViewer.brightness(_n.qs('#storyViewer .swiper-slide-active').dataset.image).then(function (brightness) {
        console.log(brightness);
        if (brightness > 200) {
          _n.qs('#storyViewer').setAttribute('lightness', 'light');
        } else {
          _n.qs('#storyViewer').setAttribute('lightness', 'dark');
        }
      });

      if (!!_n.qs('#storyViewer .next-story')) {
        if (!!_n.qs('#storyViewer .swiper').swiper.isEnd) {
          _n.qs('#storyViewer .next-story').classList.remove('dn');
        } else {
          _n.qs('#storyViewer .next-story').classList.add('dn');
        }
      }
      if (!!_n.qs('#storyViewer .prev-story')) {
        if (!!_n.qs('#storyViewer .swiper').swiper.isBeginning) {
          _n.qs('#storyViewer .prev-story').classList.remove('dn');
        } else {
          _n.qs('#storyViewer .prev-story').classList.add('dn');
        }
      }
    }, 100);
  },

  close: function close() {
    modal.close('storyViewer');
  }

};
window.StoryViewer = StoryViewer;
exports.default = StoryViewer;